module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notice":"To load this element, it is required to consent to the following cookie category: {type}."},"fi":{"notice":"Tämän sisällön näyttäminen edellyttää seuraavan evästetyypin hyväksymistä: {type}."},"sv":{"notice":"För att kunna visa detta innehåll måste du godkänna följande webbkaka: {type}"}}')
  delete Component.options._Ctor
}
